import { getFeatureEnabled, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { NotificationStyle, NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';
import cookies from 'js-cookie';
import './notification/index.js';

var COOKIE_POLICY_ACCEPTED = 'cookie-policy-accepted';
var CookiePopupComponent = /** @class */ (function (_super) {
    __extends(CookiePopupComponent, _super);
    function CookiePopupComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.topNavigationEnabled = false;
        return _this;
    }
    Object.defineProperty(CookiePopupComponent.prototype, "notificationStyle", {
        get: function () {
            return this.topNavigationEnabled
                ? NotificationStyle.TOP_NAV_COOKIE
                : NotificationStyle.MESSAGE;
        },
        enumerable: false,
        configurable: true
    });
    CookiePopupComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, cookiePopup, notification_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, getFeatureEnabled('top-navigation')];
                    case 1:
                        _a.topNavigationEnabled = _b.sent();
                        if (!cookies.get(COOKIE_POLICY_ACCEPTED)) {
                            cookiePopup = document.createElement('magic-cookie-popup-notification');
                            // temporary workaround until event bubbling works
                            // TODO: remove this event listener
                            cookiePopup.addEventListener('close', function () {
                                notificationService.close(notification_1);
                                var cookieValue = cookies.get(COOKIE_POLICY_ACCEPTED);
                                if (cookieValue === 'true') {
                                    _this.onAccepted();
                                }
                                else {
                                    _this.onRejected();
                                }
                            });
                            notification_1 = notificationService.show(cookiePopup, {
                                dismissible: true,
                                hideCloseIcon: true,
                                style: this.notificationStyle,
                                uniqueID: 'cookie-popup-text',
                                closeDelay: NotificationDelay.PERMANENT,
                                onClose: function () {
                                    if (!cookies.get(COOKIE_POLICY_ACCEPTED)) {
                                        _this.onRejected();
                                    }
                                },
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CookiePopupComponent.prototype.render = function () {
        return null;
    };
    /**
     * Emitted once the cookie popup has been accepted.
     */
    CookiePopupComponent.prototype.onAccepted = function () {
        return;
    };
    /**
     * Emitted once the cookie popup has been rejected.
     */
    CookiePopupComponent.prototype.onRejected = function () {
        return;
    };
    __decorate([
        Emit('accepted'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CookiePopupComponent.prototype, "onAccepted", null);
    __decorate([
        Emit('rejected'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CookiePopupComponent.prototype, "onRejected", null);
    CookiePopupComponent = __decorate([
        Component({
            name: 'cookie-popup',
        })
    ], CookiePopupComponent);
    return CookiePopupComponent;
}(Mixins(MagicConfigMixin)));

export default CookiePopupComponent;
